<script setup>

</script>

<template>
  <div class="pageLoader">
    <div class="d-flex h-100 align-items-center justify-content-center">
      <span class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </span>
    </div>

  </div>
</template>

<style scoped>

.pageLoader {
  background: #fff;
  opacity: .3;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

</style>
